import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState } from "react";
import { normalizePlugins } from "../utils/plugin-utils";
// @ts-ignore
const PluginCtx = createContext(undefined);
const PluginProvider = ({ children, plugins: _plugins, }) => {
    const [plugins, setPlugins] = useState(() => normalizePlugins(_plugins));
    useEffect(() => {
        setPlugins(normalizePlugins(_plugins));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_plugins]);
    return _jsx(PluginCtx.Provider, Object.assign({ value: plugins }, { children: children }));
};
export default PluginProvider;
export { PluginCtx };
